import { IMAGE_MAP2, ImageMap2Definition } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Images2BackgroundColor: Translator = sequence => {
  return translate(sequence, item => {
    if (item.__typename === 'Background') {
      // Re-used image_map2 component to make background image fit to every device used by learner.
      return {
        type: IMAGE_MAP2,
        id: item.pictures?.[0]?.id || item.id,
        values: {
          imageUrl: item.pictures?.[0]?.mediaUrl,
          isFullScreen: true,
          color: item.color || '',
          enableAudioPoints: false,
          showBackgroundImage: false
        },
        items: []
      } as ImageMap2Definition;
    }
    return null;
  });
};
